import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

import type { ComponentProps } from 'react';

const bubbleVariants = cva(
  'group/bubble relative flex w-fit max-w-[80%] min-w-0 flex-col gap-1 group-data-[align=end]/message:self-end data-[align=end]:self-end',
  {
    variants: {
      variant: {
        default:
          '[&>[data-slot=bubble-content]]:bg-secondary-active [&>[data-slot=bubble-content]]:text-foreground',
        outline: '[&>[data-slot=bubble-content]]:bg-surface-active',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

const Bubble = ({
  variant = 'default',
  align = 'start',
  className,
  ...props
}: ComponentProps<'div'> &
  VariantProps<typeof bubbleVariants> & {
    align?: 'start' | 'end';
  }) => (
  <div
    data-slot="bubble"
    data-variant={variant}
    data-align={align}
    className={cn(bubbleVariants({ variant }), className)}
    {...props}
  />
);

const BubbleContent = ({ className, ...props }: ComponentProps<'div'>) => (
  <div
    data-slot="bubble-content"
    className={cn(
      'w-fit max-w-full min-w-0 overflow-hidden rounded-xl border border-transparent px-3 py-2 text-sm leading-relaxed break-words group-data-[align=end]/bubble:self-end',
      className
    )}
    {...props}
  />
);

export { Bubble, BubbleContent };
